

export default function Footer(){


    return (
        <div>ovo je footer</div>
    );
}